module.exports = __webpack_public_path__ + "img/foot_s.511d64d4.svg";